var path = '/glow/component/glow-module/module-ugc/tpl/module-ugc.html';
var html = "<div> <thismoment-glow-module-ugc-page ng-if=$ctrl.isPage track-event=\"$ctrl.trackEvent(action, properties)\" module-id=$ctrl.moduleId name=$ctrl.name></thismoment-glow-module-ugc-page> <thismoment-glow-module-ugc-modal ng-if=\"$ctrl.isModal || $ctrl.isJs\" track-event=\"$ctrl.trackEvent(action, properties)\" module-id=$ctrl.moduleId name=$ctrl.name display-form=$ctrl.displayForm></thismoment-glow-module-ugc-modal> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-ugc/tpl/module-ugc.html
// module id = 1766
// module chunks = 1